const tabs = [
  {
    id: 'plan-info',
    name: 'ご利用プラン'
  },
  {
    id: 'user-info',
    name: 'ユーザ情報'
  },
  {
    id: 'login-info',
    name: 'ログイン情報'
  },
  {
    id: 'service-info',
    name: 'サービス情報'
  },
  {
    id: 'payment-info',
    name: '出金情報'
  },
  {
    id: 'payment-cycle',
    name: '出金サイクル'
  },
  {
    id: 'agent-notice',
    name: 'エージェント'
  },
  {
    id: 'others',
    name: 'その他'
  }
]

export default tabs



// WEBPACK FOOTER //
// ./src/common/tabs.js